import React from 'react';
import { Bookmark, BookmarkActionHandlers } from '../shared/types';
import { groupBookmarksByDate } from '../shared/utils';
import { DateGroupHeader } from '../shared/DateGroupHeader';
import { BookmarkListItem } from '../shared/BookmarkListItem';

interface GroupedListLayoutProps {
  bookmarks: Bookmark[];
  handlers: BookmarkActionHandlers;
}

export const GroupedListLayout: React.FC<GroupedListLayoutProps> = ({ bookmarks, handlers }) => {
  const bookmarkGroups = groupBookmarksByDate(bookmarks);

  return (
    <>
      {bookmarkGroups.map(group => (
        <div key={group.dateKey} className="bookmark-date-group">
          <DateGroupHeader group={group} />
          <div className="bookmarks-list grouped">
            {group.bookmarks.map(bookmark => (
              <BookmarkListItem
                key={bookmark.id}
                bookmark={bookmark}
                handlers={handlers}
                isGrouped={true}
              />
            ))}
          </div>
        </div>
      ))}
    </>
  );
};